import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormInput, CSpinner, CNav, CNavItem, CNavLink, CCardHeader, CCardTitle, CCardText, CCol, CRow } from '@coreui/react'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, AlignLeft, CirclePlus, View, Eye } from 'lucide-react'

import Pageloader from '../../components/shared/Pageloader'
import PatientInfo from './PatientInfo'
import PatientDataCRUD from '../../services/general/patientNoteData.api'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import SavePatients from '../../services/general/savePatientinformation.api'
import { HiEye } from 'react-icons/hi'
import SaveExtra from '../../services/general/saveExtraData.api'
import classNames from 'classnames'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { getAllAppointmentsDetails } from '../../components/shared/appointmentFilterData'
import AddAddendumData from '../../components/shared/AddAddendumData'

// showing only those on popup which are signed or finished aas discussed on 6aug and only visible on popup
const ProviderPatientPoupSignedChart = ({
  patientData,
  patientModelVisible,
  showNoteJustThisId,
  noteStructureRef,
  showCreateNote = true,
  setAppointmentDetails = false,
  setNoteStatus,
  noteStatus,
  patientID,
  setPatientModalVisible,
  setDataCallType,
  setShowPatientInfo,
  setEditDataId,
  setNoteID,
  patientSelected,
  showOnlyViewEye = false,
  childformData,
  setChildFormData,
  saveDiagnosisData,
  resetStates,
  setAllSelectedDiagnosis,
  breadCrumbHref,
  breadCrumbText,
  patientAppointmentID,
  appointment,
  viewPatientDetail,
  creatingNewNote,
  setCreatingNewNote,
  handleAddNoteId,
  showViewIcon = false,
  allAppointment,
}) => {
  console.log(breadCrumbHref, breadCrumbText, 'breadCrumbHref,breadCrumbText')
  console.log(allAppointment, 'allAppointment')
  const [diagnosisData, setDiagnosisData] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [boxView, setBoxView] = useState('box')
  const [warningModelVisible, setWarningModelVisible] = useState(false)
  const [patientTreatments, setPatientTreatments] = useState(null)
  const [deleteId, setDeleteId] = useState(null)
  const [allowCreateNote, setAllowCreateNote] = useState(true)
  const [allPatientVisible, setAllPatientVisible] = useState(false)
  const [showNotePatient, setShowNotePatient] = useState(false)
  const [noteId, setNodeId] = useState(null)
  const [noteIndex, setNoteIndex] = useState(false)
  const [finishNote, setFinishNote] = useState({})
  const [hasFinishNote, setHasFinishNote] = useState(false)
  const [patientAllAppointment, setPatientAllAppointment] = useState([])
  const [showAddendum, setShowAddendum] = useState(false)
  const [addendumNoteID, setAddendumNoteID] = useState(null)

  console.log('finish note ', finishNote)

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const getProvidersMaster = async () => {
    setIsPageLoading(true)
    try {
      // Fetch provider data
      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      const getUser = JSON.parse(localStorage.getItem('user'))
      console.log(getUser, providerData, 'ususeruseruseruserer')
      const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      setLoggedUserProvider(foundProvider || {})
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getProvidersMaster()
  }, [])

  const [allAppointments, setAllAppointments] = useState([])

  useEffect(() => {
    const fetchAppnt = async () => {
      const allAppntData = await getAllAppointmentsDetails('GET')
      setAllAppointments(allAppntData)
    }
    fetchAppnt()
  }, [])

  const GetPatientTreatmentsNotes = async () => {
    setIsPageLoading(true)
    console.log(allAppointments, loggedUserProvider, patientID, 'GetPatientTreatmentsNotes', 'kya nahi aaya')
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)
      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data.map((item) => {
          return {
            ...item,
            data: item.data ? JSON.parse(item?.data) : {},
          }
        })
        // const filtered = data.filter((item) => {
        //     console.log(item, 'item')
        //     const statusMatch = item.status === 'Finished' || item.status === 'Signed';
        //     console.log("Item before find:", item);

        //     const matchedAppointment = allAppointments.find(appt => {
        //         return (
        //             appt?.data?.NoteID === item?.id
        //             && appt?.data?.PatientID === patientID
        //             && appt?.data?.ProviderName === loggedUserProvider?.Name
        //         );
        //     });
        //     return statusMatch && matchedAppointment;
        // });

        // console.log(filtered, 'data going inpoop filtered')
        data = data
          ?.map((item, idx) => {
            return {
              ...item,
              finalIdx: idx,
            }
          })
          .filter((item) => (item.status === 'Finished' || item.status === 'Signed'))
          //  && item.id === showNoteJustThisId)
        console.log(data, 'brodata')
        setPatientTreatments(data)
        return data
      }
    } catch (error) {
      toast.error('error in patient treatment', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const Finish = () => {
    let finishNote = patientTreatments?.filter((item) => item.status === 'Finished')
    console.log('finshednote', finishNote)
    if (finishNote && finishNote?.length > 0) {
      setFinishNote(finishNote[finishNote.length - 1] || {})
    }
  }

  useEffect(() => {
    GetPatientTreatmentsNotes()
  }, [loggedUserProvider, patientModelVisible, allAppointments])

  useEffect(() => {
    const patientDataFn = async () => {
      // getPatientDiagnosis()

      GetPatientTreatmentsNotes()
      console.log('patient Selecteed==============> first', patientData, patientID)
      if (patientData && patientID) {
        console.log('patient Selecteed==============>', patientData, patientID)
        patientSelected(patientData)
      }
    }
    patientDataFn()
  }, [])

  const deleteShall = async (id) => {
    // const formattedJson = JSON.stringify(noteStructureRef.current)
    await PatientDataCRUD('DELETE', patientID.toString(), id.toString())
    await GetPatientTreatmentsNotes()
    setDeleteVisibleId(null)
  }
  useEffect(() => {
    Finish()
  }, [patientTreatments])

  const handleCreateNote = async () => {
    setCreatingNewNote(true)
    await PatientNoteDataCRUD('INSERT', patientID.toString(), '', JSON.stringify(noteStructureRef.current), getFormattedDate().toString())
    const patientTreatments = await GetPatientTreatmentsNotes()
    console.log(patientTreatments, 'patientTreatments[patientTreatments.length - 1];')
    let recentlyCreatedNote
    if (patientTreatments.length > 1) {
      saveDiagnosisData({
        ...patientData,
        Status: 'Follow Up',
      })

      setNoteStatus('Follow Up')
    }
    if (patientTreatments.length > 0) {
      recentlyCreatedNote = patientTreatments[patientTreatments.length - 1]
      setEditDataId(recentlyCreatedNote?.id)
    }
    console.log(recentlyCreatedNote, patientTreatments, '======recentlyCreatedNote')

    if (patientTreatments?.length !== 0) {
      setChildFormData((prev) => {
        return { ...prev, Status: 'Follow Up' }
      })

      let result = patientTreatments && patientTreatments.every((item) => item.status !== 'Signed')
      if (result) {
        setWarningModelVisible(true)
        setNoteID(patientTreatments.length - 1)
        SyncAppointmentData(recentlyCreatedNote?.id)
        setEditDataId(recentlyCreatedNote?.id)
        setDataCallType('edit')
        if (patientData?.Status === 'Follow Up') {
          //this is for case if the note id is 0 and patient created as followup then the hpi should not show, it should show the subjective, so for that we need to set the notestatus as followup.
          setNoteStatus('Follow Up')
        }
      } else {
        setEditDataId(recentlyCreatedNote?.id)
        setDataCallType('edit')
        setShowPatientInfo(true)
        setPatientModalVisible(false)
        setNoteID(patientTreatments.length - 1)
        SyncAppointmentData(recentlyCreatedNote?.id)
      }
    } else {
      console.log('else run')
      setChildFormData((prev) => {
        return { ...prev, Status: 'NewPatient' }
      })
      SyncAppointmentData(recentlyCreatedNote?.id)
      setNoteID(0)
      setDataCallType('newNote')
      setShowPatientInfo(true)
      setPatientModalVisible(false)
    }
  }

  useEffect(() => {
    if (patientTreatments && patientTreatments.length === 0) {
      setAllowCreateNote(false)
    }

    if (patientTreatments && patientTreatments.length > 0) {
      let appoinmentsData = appointment.filter((item) => item.data.AppointmentID === patientAppointmentID)

      let patientStatus = patientTreatments[patientTreatments.length - 1].status
      // if (patientStatus === 'Finished' && (appoinmentsData.length > 0 && !appoinmentsData[0].data.NoteID)) {
      //       setAllowCreateNote(false)
      //   }
      if (patientStatus === 'Finished' || patientStatus === 'Canceled') {
        setAllowCreateNote(false)
      }
    }

    if (patientTreatments && patientTreatments.length > 1) {
      //  patientSelected(patientData)
      saveDiagnosisData({
        ...patientData,
        Status: 'Follow Up',
      })
    } else if (patientTreatments && patientTreatments.length === 1) {
      // patientSelected(patientData)
      saveDiagnosisData({
        ...patientData,
        // Status: "NewPatient"
      })
    }
  }, [patientTreatments, patientData])

  const handleNoteView = (item, index) => {
    setAllPatientVisible(true)
    setNodeId(item.id)
    setNoteIndex(index)
  }

  const SyncAppointmentData = (noteID) => {
    let filterPatient = appointment && appointment.length > 0 && appointment.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled') && !item.data.NoteID)
    console.log(filterPatient, 'filterePatient data', appointment, noteID)

    if (filterPatient.length > 0) {
      if (noteID !== null || noteID !== undefined) {
        console.log('note is send==>', noteID)
        handleAddNoteId(noteID)
      }
    }
  }

  useEffect(() => {
    const getData = () => {
      let filtered = allAppointment?.filter(
        (entry) => entry.patientID === patientID,
        // entry.appointmentDetails.find((appt) => appt.data?.Status === "Finish")
      )

      console.log('filtered Appointment ', filtered, allAppointment)
      setPatientAllAppointment(filtered?.length > 0 ? filtered[0].appointmentDetails : [])
      // setHasFinishNote(filtered)
    }
    getData()
  }, [])

  const getNoteStatus = (item, index, patientData, appointmentDetails) => {
    const matchedAppointments = appointmentDetails?.filter((appt) => appt.data?.NoteID === item.id)

    const latestAppointment = matchedAppointments?.length ? matchedAppointments.sort((a, b) => new Date(b.data.CreatedDate) - new Date(a.data.CreatedDate))[0] : null
    console.log(' patinet note id', latestAppointment)
    return (latestAppointment?.data?.Type == 'New' ? 'New Note' : `Follow Up`) || 'New Note'
  }

  const getNoteStatusLabel = (item, index, patientData, appointmentDetails) => {
    console.log('appointment data ----> list', item, index, appointmentDetails)
    const matchedAppointments = appointmentDetails?.filter((appt) => appt.data?.NoteID === item.id)

    const latestAppointment = matchedAppointments?.length ? matchedAppointments.sort((a, b) => new Date(b.data.CreatedDate) - new Date(a.data.CreatedDate))[0] : null

    const type = latestAppointment?.data?.Type
    console.log('final match list data', latestAppointment, type, matchedAppointments)

    if (type === 'New') {
      return 'New Note'
    }

    if (type === 'Follow Up') {
      return index === 0 ? 'Follow Up' : `${index} Follow Up`
    }

    return index === 0 ? 'New Note' : `${index} Follow Up`
  }


   const userData = JSON.parse(localStorage.getItem('user'))

   const role = userData?.Role

  return (
    <>
      <div>
        <CCard className="m-2" style={{ border: 'none' }}>
          <CCardBody className="p-0">
            {showCreateNote && (
              <div className="d-flex align-items-center ">
                {/* <CButton
                  onClick={handleCreateNote}
                  variant="outline"
                  color="primary"
                  disabled={allowCreateNote}
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    opacity: allowCreateNote ? 0.5 : 1,
                    pointerEvents: allowCreateNote ? 'none' : 'auto',
                    borderColor: 'var(--cui-primary)',
                  }}
                >
                  <CirclePlus size={16} strokeWidth={1.25} />
                  <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>Create Note</div>
                </CButton> */}
              </div>
            )}
          </CCardBody>
        </CCard>

        <div className=" m-2 p-2 rounded-1 overflow-auto" style={{ height: '60vh', overflow: 'auto', overflow: 'auto', background: role == 'provider' ? '#282828' : 'white' }}>
          <div className="p-2">
            <CRow className="gy-4">
              {patientTreatments &&
                patientTreatments.map((item, index) => (
                  <CCol sm={12} className="d-flex ">
                    {console.log('item', item)}
                    <CCard className="w-100 shadow-sm" style={{ borderRadius: '10px', backgroundColor: role == 'provider' ? '#222222' : ' ' }}>
                      <CCardHeader className="d-flex justify-content-between align-items-center" style={{ backgroundColor: role == 'provider' ? '#191919' : '#f8f9fa', padding: '16px', borderRadius: '10px 10px 0 0' }}>
                        {/* <h6 className="m-0 text-dark">
                                                {index === 0 ? (
                                                    hasFinishNote?.length === 0
                                                        ? patientData?.Status === 'NewPatient'
                                                            ? 'New Note'
                                                            : 'Follow Up'
                                                        : 'New Note'
                                                ) : `${index} Follow Up`}
                                            </h6> */}
                        <h6 className={`m-0 ${role == 'provider' ? 'text-white' : 'text-dark'}`}>{getNoteStatusLabel(item, item?.finalIdx, patientData, patientAllAppointment)}</h6>

                        {/* <div className="d-flex align-items-center gap-1  ">
                          {item.status === 'Finished' || item.status === 'Canceled' ? (
                            <div>
                              <button
                                onClick={() => {
                                  handleNoteView(item, index)
                                }}
                                className="btn btn-outline-success btn-sm "
                                style={{ color: 'success' }}
                              >
                                <Eye size={16} strokeWidth={2.25} />
                              </button>
                              {item.id === finishNote?.id && showViewIcon && (
                                <button
                                  onClick={() => {
                                    console.log(item, 'item')
                                    setEditDataId(item.id)
                                    setDataCallType('edit')
                                    setNoteStatus(getNoteStatus(item, index, patientData, patientAllAppointment))
                                    setPatientModalVisible(false)
                                    setNoteID(index)
                                    noteStructureRef.current = item?.data
                                  }}
                                  className="btn btn-outline-warning btn-sm ms-1"
                                >
                                  <Pencil size={16} strokeWidth={2.25} />
                                </button>
                              )}
                            </div>
                          ) : (
                            <button
                              onClick={() => {
                                console.log(item, 'item')
                                setEditDataId(item.id)
                                setDataCallType('edit')
                                setNoteStatus(getNoteStatus(item, index, patientData, patientAllAppointment))
                                setPatientModalVisible(false)
                                setNoteID(index)
                                noteStructureRef.current = item?.data
                              }}
                              className="btn btn-outline-warning btn-sm "
                            >
                              <Pencil size={16} strokeWidth={2.25} />
                            </button>
                          )} */}

                        {/* only uncomment when you send the noteID as primarykey of note instead index coz it will damage flow and the whole code */}
                        {/* <button onClick={() => { setDeleteVisibleId(true); setDeleteId(item.id); }} className="btn btn-outline-danger btn-sm">
                                                    <Trash2 size={16} strokeWidth={1.75} />
                                                </button> */}
                        {/* </div> */}
                        <div className="d-flex align-items-center gap-1">
                          <button onClick={() => handleNoteView(item, item?.finalIdx)} className="btn btn-outline-success btn-sm">
                            <Eye size={16} strokeWidth={2.25} />
                          </button>
                          <button
                            // onClick={() => {
                            //   console.log(item, 'item')
                            //   setEditDataId(item.id)
                            //   setDataCallType('edit')
                            //   setNoteStatus(getNoteStatus(item, index, patientData, patientAllAppointment))
                            //   setPatientModalVisible(false)
                            //   setNoteID(index)
                            //   noteStructureRef.current = item?.data
                            // }}
                            onClick={() => {
                              setShowAddendum(true)
                              setAddendumNoteID(item?.finalIdx)
                            }}
                            className="btn btn-outline-warning btn-sm ms-1"
                          >
                            <Pencil size={16} strokeWidth={2.25} />
                          </button>
                          {/* {showOnlyViewEye ? (
                            <button onClick={() => handleNoteView(item, index)} className="btn btn-outline-success btn-sm">
                              <Eye size={16} strokeWidth={2.25} />
                            </button>
                          ) : item.status === 'Finished' || item.status === 'Canceled' ? (
                            <div>
                             
                              {item.id === finishNote?.id && showViewIcon && (
                                <button
                                  onClick={() => {
                                    console.log(item, 'item')
                                    setEditDataId(item.id)
                                    setDataCallType('edit')
                                    setNoteStatus(getNoteStatus(item, index, patientData, patientAllAppointment))
                                    setPatientModalVisible(false)
                                    setNoteID(index)
                                    noteStructureRef.current = item?.data
                                  }}
                                  className="btn btn-outline-warning btn-sm ms-1"
                                >
                                  <Pencil size={16} strokeWidth={2.25} />
                                </button>
                              )}
                            </div>
                          ) : (
                            <button
                              onClick={() => {
                                console.log(item, 'item')
                                setEditDataId(item.id)
                                setDataCallType('edit')
                                setNoteStatus(getNoteStatus(item, index, patientData, patientAllAppointment))
                                setPatientModalVisible(false)
                                setNoteID(index)
                                noteStructureRef.current = item?.data
                              }}
                              className="btn btn-outline-warning btn-sm"
                            >
                              <Pencil size={16} strokeWidth={2.25} />
                            </button>
                          )} */}
                        </div>
                      </CCardHeader>
                      <CCardBody className="d-flex align-items-center justify-content-between px-3 pt-0 ">
                        <div className={` ${role == 'provider' ? 'text-white' : 'text-dark'}`} style={{ fontSize: '14px', fontWeight: '600' }}>
                          <div>Date: {new Date(item.date).toLocaleDateString('en-us')}</div>
                          {item.flag == 'true' && item.status == 'Draft' ? <div>Status: Provider {item.status}</div> : item.flag == 'true' && item.status == 'Signed' ? <div>Status:Provider {item.status}</div> : <div>Status: {item.status}</div>}
                          {item.status === 'Canceled' && (
                            <div>
                              Reason:{' '}
                              {(() => {
                                return item?.data?.NoteCancelReason || 'N/A'
                              })()}
                            </div>
                          )}
                        </div>
                      </CCardBody>
                    </CCard>
                  </CCol>
                ))}
            </CRow>
          </div>
        </div>

        {/* delete modal */}
        <CModal visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton onClick={() => deleteShall(deleteId)} className="text-white" color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={warningModelVisible}
          onClose={() => {
            setWarningModelVisible(false)
          }}
        >
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to create new note?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setWarningModelVisible(false)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton
              onClick={() => {
                setDataCallType('newNote')
                setShowPatientInfo(true)
                setPatientModalVisible(false)
              }}
              className="text-white"
              color="warning"
            >
              Continue
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          size="xl"
          visible={allPatientVisible}
          onClose={() => {
            setAllPatientVisible(false), setShowNotePatient(false), setNodeId(null), setNoteIndex(null)
          }}
        >
          <CModalHeader
            style={{
              backgroundColor: '#282828',
              borderBottom: '1px solid gray',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              borderRadius: '10px 10px 0 0',
            }}
            className="dark-note-modal"
          >
            <CModalTitle style={{ color: 'white', width: '100%' }}>Note</CModalTitle>
          </CModalHeader>
          <CModalBody
            style={{
              backgroundColor: '#282828',
              color: 'white',
            }}
          >
            <div style={{ height: '45vw', overflow: 'auto' }}>
              <PatientInfo
                setAppointmentDetails={setAppointmentDetails}
                breadCrumbHref={breadCrumbHref}
                breadCrumbText={breadCrumbText}
                patientID={patientData.PatientID}
                patientData={patientData}
                dataCallType="edit"
                setDataId={noteId}
                noteID={noteIndex}
                showAllData={false}
                showNoteView={true}
                appointments={appointment}
              />
            </div>
          </CModalBody>

          <CModalFooter
            style={{
              backgroundColor: '#282828',
              borderTop: '1px solid gray',
              display: 'flex',
              justifyContent: 'end',
              gap: '10px',
            }}
          >
            <CButton
              onClick={() => {
                setAllPatientVisible(false)
                setShowNotePatient(false)
                setNodeId(null)
                setNoteIndex(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={showAddendum}
          size="lg"
          onClose={() => {
            setShowAddendum(false)
          }}
        >
          <CModalHeader
            style={{
              backgroundColor: '#282828',
              borderBottom: '1px solid gray',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              borderRadius: '10px 10px 0 0',
            }}
          >
            <CModalTitle style={{ color: 'white', width: '100%' }}>Add Addendum</CModalTitle>
          </CModalHeader>
          <CModalBody
            style={{
              backgroundColor: '#282828',
              color: 'white',
            }}
          >
            <div style={{ height: '70vh' }}>
              <AddAddendumData patientID={patientID} noteID={addendumNoteID} setShowAddendum={setShowAddendum} />
            </div>
          </CModalBody>
          <hr className="p-0 m-0" />
        </CModal>
        <Pageloader isLoading={isPageLoading} />
      </div>
    </>
  )
}

export default ProviderPatientPoupSignedChart
